import { useRootContext } from '~/hooks/useRootContext'
import { includes } from 'lodash-es'
import {
  setCookie as setCookieFromController,
  getCookieConsent as getCookieFromController,
} from '~/components/Cookie/controller/cookieController'
import { useEffect, useState } from 'react'

const ESSENTIAL_COOKIES = ['__cfduid', 'vanity_id', '_session_id', 'refferal_id', 'RC Cookie']
const ANALYTICAL_COOKIES = [
  '_ga',
  '_gid',
  '_gat_UA-52581310-5',
  'PLAY_SESSION',
  'headway_session',
  'persist:hs-beacon-*',
]
const MARKETING_AND_TRACKING_COOKIES = [
  '_gcl_au',
  '_lfa',
  'IDE',
  'test_cookie',
  'MUID',
  '_uetsid',
  '_uetvid',
  'NID',
  '_fbp',
  'fr',
  'tr.',
]

const COOKIE_KEY = {
  preferenceSaved: 'cookie_preference_saved',
}

const useCookies = () => {
  const { cookie_consent } = useRootContext()

  const [isPreferenceSaved, setIsPreferenceSaved] = useState<boolean>(true)

  const getCookieTypeByKey = (key: string) => {
    if (includes(ESSENTIAL_COOKIES, key)) return 'essentialCookies'
    if (includes(ANALYTICAL_COOKIES, key)) return 'analyticalCookies'
    if (includes(MARKETING_AND_TRACKING_COOKIES, key)) return 'marketingAndTrackingCookies'
    return 'unknown'
  }

  useEffect(() => {
    const value = window.localStorage.getItem(COOKIE_KEY.preferenceSaved)
    setIsPreferenceSaved(value === 'true')
  }, [])

  const handlePreferenceSave = (value: boolean) => {
    setIsPreferenceSaved(value)
    localStorage.setItem(COOKIE_KEY.preferenceSaved, value ? 'true' : 'false')
  }

  const setCookie = (key: string, value: string, domain: string, expires: number | string) => {
    getCookieTypeByKey(key)
    setCookieFromController(key, value, domain, expires)
  }

  const getCookie = (name: string) => {
    return getCookieFromController(name)
  }

  return {
    setCookie,
    getCookie,
    handlePreferenceSave,
    isPreferenceSaved,
    cookie_consent,
  }
}

export default useCookies
